import React, { ReactNode } from 'react';
import classnames from 'classnames';

import {
  Card,
  CardActions,
  CardBody,
  CardImage,
  Checkbox,
  RadioButton,
} from '@BICE_Vida/components';

import { Badge } from '@BICE_Vida/scp-components';
import styles from './CardSelectable.module.scss';

type CardSelectableT = {
  id?: string;
  selector?: 'radio' | 'check';
  className?: string;
  checked?: boolean;
  title?: string;
  description?: string;
  onClick?: () => void;
  children?: ReactNode;
  image?: string;
  action?: ReactNode;
  disabled?: boolean;
  badge?: string;
};

const CardSelectable = ({
  id,
  selector,
  className,
  checked = false,
  title,
  description,
  children,
  onClick,
  image,
  action,
  disabled = false,
  badge,
}: CardSelectableT) => {
  const cardClasses = classnames(styles.card_selectable, {
    [styles.card_selectable_disabled]: disabled,
    [`${className}`]: className,
  });

  return (
    <Card id={id} className={cardClasses} selectable checked={checked} onChange={onClick}>
      <CardBody
        direction="row"
        image={
          image ? (
            <CardImage className={styles.card_image} image={image} variant="circle" />
          ) : undefined
        }
        title={title}
        description={description}
        className={styles.card_selectable_body}
        actions={
          <CardActions className={styles.card_selectable_actions}>
            {action}
            {selector === 'radio' && (
              <RadioButton
                name={`${id}_card_selectable`}
                disabled={disabled}
                checked={checked}
                className={styles.card_selectable_selector}
              />
            )}
            {selector === 'check' && (
              <Checkbox
                disabled={disabled}
                checked={checked}
                className={styles.card_selectable_selector}
              />
            )}
            {badge && <Badge className={styles.card_selectable_badge} text={badge} />}
          </CardActions>
        }
      >
        {children}
      </CardBody>
    </Card>
  );
};

export default CardSelectable;
